/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { SetAdminCompetitionRankingSourceResponse, SetAdminCompetitionRankingSourceVars } from '../openapi-types.gen.js';

export type { SetAdminCompetitionRankingSourceResponse, SetAdminCompetitionRankingSourceVars } from '../openapi-types.gen.js';

export const useSetAdminCompetitionRankingSource = createMutationHook<SetAdminCompetitionRankingSourceVars, SetAdminCompetitionRankingSourceResponse, unknown>({
  specName: 'useSetAdminCompetitionRankingSource',
  path: '/v1/admin/competitions/{competitionId}/ranking-source',
  method: 'PUT',
  resolveUrl: (vars: SetAdminCompetitionRankingSourceVars) => `/v1/admin/competitions/${vars.competitionId}/ranking-source`,
  buildBody: (vars: SetAdminCompetitionRankingSourceVars) => ({ source: vars.source }),
  parseResponse: (raw: unknown): SetAdminCompetitionRankingSourceResponse => raw as SetAdminCompetitionRankingSourceResponse,
  optimistic: [{
    queryKey: ['admin', 'detail'],
    apply: (prev: any, vars: SetAdminCompetitionRankingSourceVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      if (vars.source !== undefined) next = { ...next, rankingSource: vars.source };
      return next;
    },
  }],
  
  
});
